import { Button } from "@shared/components/untitledui/base/buttons/button"
import type { ReactNode } from "react"
import { ViewShell } from "./ViewShell"

/**
 * A drilled-in informational view: body text plus a single acknowledge button (the
 * headline is the view's title in the menu's header bar). Used when an action can't
 * proceed and we only need to explain why — the drill-down replacement for a plain
 * warning `swal`.
 */
export function InfoView({
  body,
  doneLabel = "Got it",
  onDone,
}: {
  body: ReactNode
  doneLabel?: string
  onDone: () => void
}) {
  return (
    <ViewShell
      actions={
        <Button data-test="view done" color="primary" size="md" className="flex-1" onPress={onDone}>
          {doneLabel}
        </Button>
      }
    >
      <p className="m-0 px-5 pt-4 text-base text-gray-700">{body}</p>
    </ViewShell>
  )
}
